import { IQueryParser, createParamContext } from 'app/components/router/createParamContext';
import { Set, List } from 'immutable';
import { decodeWithDefault } from 'app/utils/ioTs';
import * as iots from 'io-ts';
import { filterType } from 'app/utils/immutable';
import { AuthProvider, AuthProviderCodec, DMM, FACEBOOK } from 'app/constants/enums/AuthProvider';
import appConfig from 'app/config/client';
import { RunningIn } from 'app/config/types/DeployInfo';

interface IEnvironmentSpecificProviderBrand {
  readonly EnvironmentSpecificProvider: unique symbol;
}

export const makeEnvironmentSpecificProvider = (runningIn: RunningIn) => iots.brand(
  AuthProviderCodec,
  (x): x is iots.Branded<AuthProvider, IEnvironmentSpecificProviderBrand> => {
    if (runningIn === RunningIn.Production) {
      return x === DMM || x === FACEBOOK;
    } else {
      return true;
    }
  },
  'EnvironmentSpecificProvider',
);

const EnvironmentSpecificProvider = makeEnvironmentSpecificProvider(appConfig.deployInfo.runningIn);

export const authProvidersParser: IQueryParser<Set<AuthProvider> | undefined> = {
  serialize: (values) => ({ providers: values && values.map(AuthProviderCodec.encode).join(',') }),
  deserialize: (query) => {
    if (query.providers && typeof query.providers === 'string') {
      const values = query.providers.split(',');
      const providersOrNull = values.map(
        possibleProvider => decodeWithDefault(EnvironmentSpecificProvider, possibleProvider, null),
      );
      const filtered = filterType<AuthProvider, null>(List(providersOrNull), (x): x is null => x === null).toSet();
      return filtered.isEmpty() ? undefined : filtered;
    }
    return undefined;
  },
};

export const {
  Provider: AuthProvidersParamProvider,
  Consumer: AuthProvidersParamConsumer,
  useParams: useAuthProviders,
} = createParamContext(authProvidersParser);
